/**
 * Vehicle insurance coverage type values
 */
export enum VehicleInsuranceCoverageTypeEnum {
	THIRD_PARTY = 'third_party',
	COMPREHENSIVE = 'comprehensive',
	COMPREHENSIVE_PLUS = 'comprehensive_plus',
}
